var jsbridge = require("@tencent/txmv-core/jsbridge");
module.exports = function (config, _callback) {
	var callbacked = false;
	//只callback一次
	var callback = function () {
		if (callbacked) {
			return;
		}
		callbacked = true;
		_callback.apply(this, arguments);
	};
	/**
	 * 出问题时判断为未安装，不考虑无法判断
	 */
	jsbridge(function (success) {
		if (success) {
			check(config, function (err, rs) {
				callback(err, rs)
			});
		} else {
			callback(null, 0);
		}
	});
	setTimeout(function () {
		callback(null, 0);
	}, 10000);
};

function check(config, callback) {
	var WeixinJSBridge = window.WeixinJSBridge;

	//判断在正常页面和在iframe内部的情况
	if (!WeixinJSBridge.invoke) {
		callback(new Error('could not access weixinjsbridge'));
	}

	//拿到上网环境方便banner上报
	//self.getNetworkTypeInWechat().done(function(nettype) {
	//	if (op && op.t && op.t.config) {
	//		op.t.config.nettype = nettype;
	//	}
	//});
	setTimeout(function () {
		WeixinJSBridge.invoke('getInstallState', {
			"packageUrl": config.pkgurl,
			"packageName": config.pkg
		}, function (n) {
			var o = n.err_msg;
			if (o.indexOf("get_install_state:yes") > -1) {
				callback(null, 1);
			} else {
				callback(null, 0);
			}
		});
	}, 50);
}